import { RiContactsBook2Line } from 'react-icons/ri';

const ListItem = ({ item, onClick }) => {
    return (
        <li onClick={() => onClick(item)}>
            <span className='avatar--'>
                <span className='avatar--list'>
                    <RiContactsBook2Line />
                </span>
            </span>
            <span className='info--'>
                <span className='name'>{item.nome}</span>
                <span className='description'>
                    {item?.descricao ? item?.descricao : '...'}
                </span>
            </span>
        </li>
    );
};

export default ListItem;